import React from 'react';
import CustomButton from '../Button';
import './Dialog.css';
const Dialog = (props) => {
    const handleKeyDown = (event) => {
        if (event.key === 'Escape')
            props.onCancel?.();
    };
    if (!props.visible)
        return null;
    return (React.createElement("dialog", { id: props.id ?? 'custom-dialog', className: `custom-dialog ${props.className ?? ''}`, style: props.style, onKeyDown: handleKeyDown },
        React.createElement("div", null,
            React.createElement("h1", { className: "text-3xl font-bold text-blue-900", style: { fontSize: '22px', color: '#202e45', lineHeight: '28px', fontWeight: 700, letterSpacing: '-.2px' } }, props.title),
            props.content && React.createElement("div", null, props.content)),
        !props.customButtons && (React.createElement("div", { className: "flex flex-row justify-between mt-12" },
            props.onCancel && React.createElement(CustomButton, { title: props.cancelText ?? 'Stäng', onClick: () => props.onCancel?.() }),
            props.onOk && (React.createElement(CustomButton, { type: "primary", loading: props.okLoading, title: props.okText ?? 'Confirm', onClick: () => props.onOk?.() })))),
        props.customButtons && (React.createElement("div", { className: "flex flex-row justify-between flex-wrap gap-4 mt-12" }, props.customButtons))));
};
export default Dialog;
